export default {"src":"/_next/static/media/roadwise-logo-white-fr.6e021088.svg","height":47,"width":109,"blurWidth":0,"blurHeight":0};